import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';


export class SorderLine extends BaseEntity {
  
  sorderLineNumber    : number;
  product             : Product;

  quantity                 : number = 0;
  returnedQuantity         : number = 0;
  returnedDamagedQuantity1 : number = 0;
  returnedDamagedQuantity2 : number = 0;

  deliveredQuantity        : number = 0;
  unitPrice                : number = 0;

  freeGoodLine             : boolean = false;
  orderability             : boolean = false;
  priority                 : boolean = false;


  constructor() {
    super()
  }
 
}
 


